// @flow
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import { I18n } from 'aws-amplify';
import React from 'react';

type Props = {
    tooltip?: string,
    onClick: Function,
};

export default function RefreshToolbarButton({ tooltip, onClick }: Props) {
    return (
        <Tooltip title={tooltip || I18n.get('Refresh')}>
            <IconButton onClick={onClick}>
                <RefreshIcon />
            </IconButton>
        </Tooltip>
    );
}
